var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19845",
    "data-name": "Gruppe 19845",
    transform: "translate(-456 -534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25152",
    "data-name": "Rechteck 25152",
    width: 40,
    height: 40,
    transform: "translate(456 534)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_161",
    "data-name": "Differenzmenge 161",
    d: "M8618.365,18102.992a19.157,19.157,0,0,1-13-5.6A18.151,18.151,0,0,1,8600,18084.5a17.953,17.953,0,0,1,1.493-7.2,18.416,18.416,0,0,1,4.071-5.879,18.945,18.945,0,0,1,6.039-3.965,19.314,19.314,0,0,1,7.4-1.455c.558,0,1.123.025,1.681.072-.288-.01-.492-.014-.682-.014a18.5,18.5,0,0,0-1.636,36.93Z",
    transform: "translate(-8143.999 -17530.529)",
    fill: "#8f8f8f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderIcon);
export default __webpack_public_path__ + "static/media/loader_icon.b42057fc9eae1d844ed757b51fc7d216.svg";
export { ForwardRef as ReactComponent };